import React, { useState } from "react";
import PayableCard from './PayableCard'
import { ChevronLeft, ChevronRight, SlidersVertical } from 'lucide-react'
import PayableDetail from './PayableDetail'
import { UpcomingPaymentsResponse, UpcomingPaymentItem } from '../../../api/types';
import Alert from '../../../components/Alert'
import { useIsMobile } from '../../../utils/hooks'

interface PaymentsProps {
    handleSubPage: (page: string) => void
    data: UpcomingPaymentsResponse | undefined
}

const Payables: React.FC<PaymentsProps> = ({ handleSubPage, data }) => {
    const [page, setPage] = useState(1);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedData, setSelectedData] = useState<UpcomingPaymentItem | null>(null)
    const isMobile = useIsMobile()

    if (!data || data.items.length == 0) {
        return (
            <div className="w-full bg-white rounded-xl border p-5 flex flex-col flex-1">
                <div className="subpage-header-container">
                    <button onClick={() => handleSubPage("dashboard")}>
                        <ChevronLeft />
                    </button>
                    <h2 className="font-semibold">
                        Payables
                    </h2>
                </div>
                <div className="flex-1 flex items-center justify-center my-16">
                    <Alert label={"No data available"} subtitle={""} />
                </div>
            </div>
        )
    }

    return (
        <div className="flex-1 m-5">
            {showDetails && <PayableDetail data={selectedData} onClose={() => setShowDetails(false)} />}

            {isMobile ?
                <div>
                    <div className="subpage-header-container">
                        <button onClick={() => handleSubPage("dashboard")}>
                            <ChevronLeft />
                        </button>
                        <h2>Payables</h2>
                    </div>
                    {/* Payment Rows */}
                    <div className="mt-5 flex flex-col gap-3">
                        {data.items.map((payment, index) => (
                            <div onClick={() => {
                                setShowDetails(true)
                                setSelectedData(payment)
                            }}>
                                <PayableCard
                                    key={index}
                                    title={payment.data.name}
                                    date={payment.data.recurring_info.schedule.next_date}
                                    method={payment.data.type}
                                    category={payment.data.line_items[0].account.name}
                                    amount={payment.data.total_amount}
                                    collapsed={false}
                                    inSubpage={true}
                                />
                            </div>
                        ))}
                    </div>
                </div> :
                <>
                    <div className="subpage-header-container">
                        <button onClick={() => handleSubPage("dashboard")}>
                            <ChevronLeft />
                        </button>
                        <h2>Payables</h2>
                    </div>

                    {/* Table */}
                    <div className="overflow-x-auto">
                        <div className="min-w-[1000px]">
                            {/* Headers */}
                            <div className="table-header grid-cols-[2fr_1fr_1fr_1fr_1fr_2fr_auto]">
                                <div>Transaction</div>
                                <div>Amount</div>
                                <div>Account</div>
                                <div>Due in</div>
                                <div>Category</div>
                                <div>Tags or Remarks</div>
                                <div className="flex justify-end"><SlidersVertical /></div>
                            </div>

                            {/* Payment Rows */}
                            <div className="mt-5 flex flex-col gap-3">
                                {data.items.map((payment, index) => (
                                    <div onClick={() => {
                                        setShowDetails(true)
                                        setSelectedData(payment)
                                    }}>
                                        <PayableCard
                                            key={index}
                                            title={payment.data.name}
                                            date={payment.data.recurring_info.schedule.next_date}
                                            method={payment.data.type}
                                            category={payment.data.line_items[0].account.name}
                                            amount={payment.data.total_amount}
                                            collapsed={false}
                                            inSubpage={true}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </>
            }

            {/* Pagination */}
            {/* <div className="flex gap-3 pt-5 text-gray-700 font-semibold items-center w-full justify-center">
                <button><ChevronLeft className="text-gray-400 w-7 h-7" /></button>
                {[1, 2, 3, 4, "...", 6].map((n, i) => (
                    <button
                        key={i}
                        onClick={() => typeof n === "number" && setPage(n)}
                        className={`${page === n ? "bg-gray-300 text-white py-1 px-3 rounded-lg" : ""
                            }`}
                        disabled={n === "..."}
                    >
                        {n}
                    </button>
                ))}
                <button><ChevronRight className="text-gray-400 w-7 h-7" /></button>
            </div> */}
        </div>
    );
};

export default Payables;
